import YIntersect from './Intersect.vue';

export default YIntersect;

export { YIntersect };
